import { useQuery } from '@tanstack/react-query';
import { importService } from '../api/api';

interface BatchListParams {
    page?: number;
    limit?: number;
    status?: string;
    searchKey?: string;
}

export const useBatchList = (params: BatchListParams = {}) => {
    const { data, isLoading, error, isError, refetch, isRefetching } = useQuery({
        queryKey: ['batchList', params],
        queryFn: () => importService.getBatchList(params),
    });

    return {
        data: data?.rows || [],
        pagination: data?.pagination,
        isLoading: isLoading || isRefetching,
        error,
        isError,
        refetch,
    };
};
